import {
  Box,
  Button,
  Checkbox,
  Drawer,
  FormControl,
  FormControlLabel,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import { useGetPaymentMethods } from "src/api/generic";
import FilterIcon from "src/assets/svg-icons/aggregators/filter.svg";
import { useTranslation } from "react-i18next";
import { useGetSuppliersList } from "src/api/purchasing/suppliers";
import { useGetOCAccountsList } from "src/api/operation-cost/accounts";
import { useState } from "react";
import { useGetVendorsList } from "src/api/operation-cost/vendors";

interface IProps {
  open: boolean;
  handleClose: any;
  refNum: string;
  setRefNum: Function;
  type: string;
  setType: Function;
  paymentId: string;
  setPaymentId: Function;
  supplierId: string;
  setSupplierId: Function;
  vendorId: string;
  setVendorId: Function;
  accountId: string;
  setAccountId: Function;
  isGovernmentTax: boolean;
  setIsGovernmentTax: Function;
}
const FilterDrawer = (props: IProps) => {
  const {
    open,
    handleClose,
    refNum,
    setRefNum,
    type,
    setType,
    paymentId,
    setPaymentId,
    supplierId,
    setSupplierId,
    vendorId,
    setVendorId,
    accountId,
    setAccountId,
    isGovernmentTax,
    setIsGovernmentTax,
  } = props;
  const { t } = useTranslation("purchasing");
  const { t: generalT } = useTranslation("general");

  const [tempRefNum, setTempRefNum] = useState(refNum);
  const [tempPaymentId, setTempPaymentId] = useState(paymentId);
  const [tempSupplierId, setTempSupplierId] = useState(supplierId);
  const [tempVendorId, setTempVendorId] = useState(vendorId);
  const [tempAccountId, setTempAccountId] = useState(accountId);
  const [tempType, setTempType] = useState(type);
  const [tempIsGovernmentTax, setTempIsGovernmentTax] =
    useState(isGovernmentTax);

  // APIS
  const { data: paymentsData } = useGetPaymentMethods();
  const { data: suppliersData } = useGetSuppliersList();
  const { data: vendorsData } = useGetVendorsList();
  const { data: accountsData } = useGetOCAccountsList();

  const handleApply = () => {
    handleClose();
    setRefNum(tempRefNum);
    setPaymentId(tempPaymentId);
    setSupplierId(tempSupplierId);
    setVendorId(tempVendorId);
    setType(tempType);
    setIsGovernmentTax(tempIsGovernmentTax);
    setAccountId(tempAccountId);
  };

  const handleClearFilters = () => {
    handleClose();
    setRefNum("");
    setPaymentId();
    setSupplierId();
    setVendorId();
    setAccountId();
    setType();
    setIsGovernmentTax(false);

    setTempRefNum("");
    setTempPaymentId("");
    setTempSupplierId("");
    setTempVendorId("");
    setTempAccountId("");
    setTempType("");
    setTempIsGovernmentTax(false);
  };

  const Types = [
    {
      label: "eventOfOwner",
      value: "owner",
    },
    {
      label: "eventOfSupplier",
      value: "supplier",
    },
    {
      label: "eventOfPayment",
      value: "payment",
    },
    {
      label: "eventOfExpenses",
      value: "liability",
    },
    {
      label: "fixedAsset",
      value: "fixed_asset",
    },
    {
      label: "vendorEvent",
      value: "vendor",
    },
    {
      label: "otherRevenueEvent",
      value: "other_revenue",
    },
    {
      label: "InventoryEvent",
      value: "inventory",
    },
    {
      label: "employeeEvent",
      value: "employee",
    },
  ];

  return (
    <Drawer anchor={"right"} open={open} onClose={handleClose}>
      <Stack
        maxWidth={{ xs: "100%", sm: "376px" }}
        minWidth={{ xs: "100%", sm: "376px" }}
        borderRight={"1px solid #D0D5DD"}
        height={"100%"}
        maxHeight={"100vh"}
        top={"0"}
      >
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          p={"20px 27px"}
          bgcolor={"#fff"}
          boxShadow="0px 0px 40px 0px rgba(11, 24, 42, 0.07)"
        >
          <Button
            color="tertiary"
            variant="text"
            size="small"
            endIcon={<img src={FilterIcon} height={"16px"} alt="" />}
          >
            {t("filter")}
          </Button>
          <Button
            variant="outlined"
            color="tertiary"
            size="small"
            onClick={handleClose}
          >
            {t("hide")}
          </Button>
        </Box>
        <Stack spacing={"20px"} p={"40px 27px"}>
          <TextField
            label={t("reference")}
            variant="outlined"
            size="small"
            fullWidth
            value={tempRefNum}
            onChange={(e) => setTempRefNum(e.target.value)}
          />
          {/*  type */}
          <FormControl fullWidth size="small">
            <InputLabel id="demo-multiple-checkbox-label">
              {t("type")}
            </InputLabel>
            <Select
              labelId="demo-multiple-checkbox-label"
              id="demo-multiple-checkbox"
              value={tempType}
              onChange={(e) => setTempType(e.target.value)}
              input={<OutlinedInput label={t("type")} />}
            >
              {Types.map(({ label, value }) => (
                <MenuItem key={value} value={value}>
                  <ListItemText primary={t(label)} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {/*  payment Method  Select */}
          <FormControl fullWidth size="small">
            <InputLabel id="demo-multiple-checkbox-label">
              {t("paymentMethod")}
            </InputLabel>
            <Select
              labelId="demo-multiple-checkbox-label"
              id="demo-multiple-checkbox"
              value={tempPaymentId}
              onChange={(e) => setTempPaymentId(e.target.value)}
              input={<OutlinedInput label={t("paymentMethod")} />}
            >
              {paymentsData?.data?.map((payment: any) => (
                <MenuItem key={payment.id} value={payment.id}>
                  <ListItemText primary={payment.name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {/*  Supplier Select */}
          <FormControl fullWidth size="small">
            <InputLabel id="demo-multiple-checkbox-label">
              {t("supplier")}
            </InputLabel>
            <Select
              labelId="demo-multiple-checkbox-label"
              id="demo-multiple-checkbox"
              value={tempSupplierId}
              onChange={(e) => setTempSupplierId(e.target.value)}
              input={<OutlinedInput label={t("supplier")} />}
            >
              {suppliersData?.data?.map((sup: any) => (
                <MenuItem key={sup.id} value={sup.id}>
                  <ListItemText primary={sup.name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {/*  Vendor Select */}
          <FormControl fullWidth size="small">
            <InputLabel id="demo-multiple-checkbox-label">
              {generalT("vendor")}
            </InputLabel>
            <Select
              labelId="demo-multiple-checkbox-label"
              id="demo-multiple-checkbox"
              value={tempVendorId}
              onChange={(e) => setTempVendorId(e.target.value)}
              input={<OutlinedInput label={generalT("vendor")} />}
            >
              {vendorsData?.data?.map((sup: any) => (
                <MenuItem key={sup.id} value={sup.id}>
                  <ListItemText primary={sup.name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {/*  Account Select */}
          <FormControl fullWidth size="small">
            <InputLabel id="demo-multiple-checkbox-label">
              {t("expensesAccount")}
            </InputLabel>
            <Select
              labelId="demo-multiple-checkbox-label"
              id="demo-multiple-checkbox"
              value={tempAccountId}
              onChange={(e) => setTempAccountId(e.target.value)}
              input={<OutlinedInput label={t("expensesAccount")} />}
            >
              {accountsData?.data?.map((account: any) => (
                <MenuItem key={account.id} value={account.id}>
                  <ListItemText primary={account.name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControlLabel
            control={
              <Checkbox
                sx={{ paddingY: "0" }}
                checked={tempIsGovernmentTax}
                value={tempIsGovernmentTax}
                onChange={(e) => setTempIsGovernmentTax(e.target.checked)}
              />
            }
            label={t("dueToGovernmentTax")}
          />
          {/* divider */}
          <Box width={"100%"} height={"1px"} bgcolor={"#CBD5E1"} />
        </Stack>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          p={"20px 27px"}
          bgcolor={"#fff"}
          boxShadow="0px 0px 40px 0px rgba(11, 24, 42, 0.07)"
          alignItems={"flex-end"}
          mt="auto"
        >
          <Button variant="contained" size="small" onClick={handleApply}>
            {generalT("apply")}
          </Button>
          <Button
            variant="outlined"
            color="tertiary"
            size="small"
            onClick={handleClearFilters}
          >
            {generalT("clear")}
          </Button>
        </Box>
      </Stack>
    </Drawer>
  );
};
export default FilterDrawer;
